import Dialog from '@mui/material/Dialog';
import { Box, CircularProgress } from '@mui/material';

interface Props {
  open: boolean;
}

const LoaderFullScreen = (props: Props) => {
  const { open } = props;

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: { background: 'transparent' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'hidden',
          height: '100%',
        }}
      >
        <CircularProgress style={{ color: '#fff' }} />
      </Box>
    </Dialog>
  );
};

export default LoaderFullScreen;
